<template>
  <div class="cmp-dashboard">
    <!-- Header: Selectores + KPIs de comparación -->
    <div class="cmp-dashboard__header">
      <CMPSelectorPeriodo
        :periodo-a="periodoA"
        :periodo-b="periodoB"
        @update:periodo-a="actualizarPeriodoA"
        @update:periodo-b="actualizarPeriodoB"
      />

      <!-- KPI: Piezas fabricadas (A vs B) -->
      <div class="cmp-dashboard__kpi-card">
        <span class="cmp-dashboard__kpi-etiqueta">Piezas fabricadas (A vs B)</span>
        <div
          class="cmp-dashboard__kpi-valor"
          :class="
            diferenciasPiezas >= 0
              ? 'cmp-dashboard__kpi-valor--positivo'
              : 'cmp-dashboard__kpi-valor--negativo'
          "
        >
          <span class="cmp-dashboard__kpi-icono">
            {{ diferenciasPiezas >= 0 ? "▲" : "▼" }}
          </span>
          <span
            >{{ diferenciasPiezas >= 0 ? "+" : ""
            }}{{ formatearPiezas(diferenciasPiezas) }}</span
          >
        </div>
      </div>

      <!-- KPI: Consumo de MP (A vs B) -->
      <div class="cmp-dashboard__kpi-card">
        <span class="cmp-dashboard__kpi-etiqueta">Consumo de MP (A vs B)</span>
        <div
          class="cmp-dashboard__kpi-valor"
          :class="
            diferenciasKg <= 0
              ? 'cmp-dashboard__kpi-valor--positivo'
              : 'cmp-dashboard__kpi-valor--negativo'
          "
        >
          <span class="cmp-dashboard__kpi-icono">
            {{ diferenciasKg <= 0 ? "▼" : "▲" }}
          </span>
          <span
            >{{ diferenciasKg >= 0 ? "+" : "" }}{{ formatearKg(diferenciasKg) }} kg</span
          >
        </div>
      </div>
    </div>

    <!-- Body: Panel lateral + Gráfica -->
    <div class="cmp-dashboard__body">
      <CMPPanelResumen
        :total-piezas-a="totalPiezasA"
        :total-piezas-b="totalPiezasB"
        :filas-t-p-u="filasTPU"
        :total-kg-a="totalKgA"
        :total-kg-b="totalKgB"
      />

      <div class="cmp-dashboard__grafica">
        <div v-if="cargando" class="cmp-dashboard__loading">Cargando datos...</div>
        <CMPGraficaBarras
          v-else
          :semanas="semanasPlanReal"
          titulo="Plan de producción vs producción real"
          :subtitulo="etiquetaPeriodo(periodoA)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from "vue";

import CMPSelectorPeriodo from "./components/CMPSelectorPeriodo.vue";
import CMPPanelResumen from "./components/CMPPanelResumen.vue";
import CMPGraficaBarras from "./components/CMPGraficaBarras.vue";
import { useConsumoMateriaPrima } from "./composables/useConsumoMateriaPrima";

import "./styles/consumo-mp.css";

const {
  cargando,
  periodoA,
  periodoB,
  semanasPlanReal,
  totalPiezasA,
  totalPiezasB,
  filasTPU,
  totalKgA,
  totalKgB,
  etiquetaPeriodo,
  cargarTodo,
  actualizarPeriodoA,
  actualizarPeriodoB,
} = useConsumoMateriaPrima();

const diferenciasPiezas = computed(() => totalPiezasA.value - totalPiezasB.value);
const diferenciasKg = computed(() => totalKgA.value - totalKgB.value);

function formatearPiezas(valor) {
  if (valor === null || valor === undefined) return "—";
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(valor);
}

function formatearKg(valor) {
  if (valor === null || valor === undefined) return "—";
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(valor);
}

onMounted(() => cargarTodo());
</script>
